import {
    GET_PARTNER_FAILED,
    GET_PARTNER_LOADING,
    GET_PARTNER_SUCCESS,
    GET_PARTNER_REMOVE
} from "../types";

const initialState = {
    partnerData: null,
    loading: null,
    error: null,
    partnerId: null,
};

export const partnerReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: { partnerId: any }; error: any }
) => {
    switch (action.type) {
        case GET_PARTNER_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_PARTNER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                partnerData: action.payload,
                partnerId: action.payload.partnerId,
            };
        case GET_PARTNER_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                partnerId: null,
            };
        case GET_PARTNER_REMOVE:
            return {
                ...initialState,
            };

        default:
            return state;
    }
};
